module.exports = __webpack_public_path__ + "img/m_award_img03.920fb83b.jpg";